module.exports = __webpack_public_path__ + "static/media/exploded_GreatIcosahedron.be041561.gif";